export const sizes = [
  { id: 1, name: "Solo" },
  { id: 10, name: "2–3 people" },
  { id: 50, name: "4–6 people" },
  { id: 250, name: "7–10 people" },
  { id: 500, name: "11+ people" },
];
